<div class="formly-field-wrap user-role-assignments-wrap">
  @if (isLoading) {
    <div class="state-block">
      <span>{{ 'COMMON.LOADING' | translate }}</span>
    </div>
  } @else if (loadError) {
    <div class="state-block">
      <span>{{ 'USER_ROLE_ASSIGNMENTS.LOAD_FAILED' | translate }}</span>
      <button type="button" class="secondary-button" (click)="retryLoad()">
        {{ 'ERRORS.RETRY' | translate }}
      </button>
    </div>
  } @else if (isReadonly) {
    <div class="readonly-list">
      @if (roleAssignments.length === 0) {
        <div class="readonly-empty">{{ 'USER_ROLE_ASSIGNMENTS.EMPTY' | translate }}</div>
      } @else {
        @for (assignment of roleAssignments; track trackByIndex($index)) {
          <div class="readonly-row">
            <div class="readonly-role">{{ getRoleLabel(assignment.roleId) }}</div>
            <div class="readonly-subsidiary">{{ getSubsidiaryLabel(assignment.subsidiaryId) }}</div>
          </div>
        }
      }
    </div>
  } @else {
    <div class="editor-shell">
      @if (roleOptions.length === 0) {
        <div class="state-block empty-inline">{{ 'USER_ROLE_ASSIGNMENTS.EMPTY' | translate }}</div>
      } @else {
        <div class="table-shell">
          <table class="assignments-table">
            <thead>
              <tr>
                <th>{{ 'USER_ROLE_ASSIGNMENTS.ROLE' | translate }}</th>
                <th>{{ 'USER_ROLE_ASSIGNMENTS.SUBSIDIARY' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (role of roleOptions; track trackByRoleId($index, role)) {
                <tr>
                  <td>
                    <div class="role-cell">
                      <label class="role-selection-label">
                        <input
                          type="checkbox"
                          class="role-checkbox"
                          [checked]="isRoleAssigned(role.roleId)"
                          [attr.aria-label]="getRoleOptionLabel(role)"
                          [title]="getRoleOptionLabel(role)"
                          (change)="onRoleCheckedChange(role.roleId, $any($event.target).checked)">
                        <span class="role-label-group">
                          <span class="role-name">{{ getRoleOptionLabel(role) }}</span>
                          <span class="role-id">{{ role.roleId }}</span>
                        </span>
                      </label>
                      @if (hasRoleHelpText(role)) {
                        <button
                          type="button"
                          class="role-help-button"
                          aria-label="Help"
                          title="Help"
                          (click)="showRoleHelp(role, $event)">
                          <i class="fa-solid fa-circle-question" aria-hidden="true"></i>
                        </button>
                      }
                    </div>
                  </td>
                  <td>
                    <select
                      class="row-select"
                      title="{{ 'USER_ROLE_ASSIGNMENTS.SUBSIDIARY' | translate }}"
                      [disabled]="!isRoleAssigned(role.roleId)"
                      [ngModel]="getSubsidiaryValueForRole(role.roleId)"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="onSubsidiaryChange(role.roleId, $event)">
                      <option value="">{{ 'USER_ROLE_ASSIGNMENTS.ALL_SUBSIDIARIES' | translate }}</option>
                      @for (subsidiary of subsidiaryOptions; track subsidiary.subsidiaryId) {
                        <option [value]="subsidiary.subsidiaryId">{{ subsidiary.name }} ({{ subsidiary.subsidiaryId }})</option>
                      }
                    </select>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }
  <ng-template #fieldComponent></ng-template>
</div>